import type { ReactNode } from 'react'
import type { PageHeaderSearch } from '@/components/layout/PageHeader'
import { PageLayout } from '@/components/layout/PageLayout'
import { Skeleton } from '@/components/ui/skeleton'

type PageSkeletonProps = {
  title?: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  bottomActions?: ReactNode
  search?: PageHeaderSearch
  contentClassName?: string
  children: ReactNode
}

const noop = () => {}

export function PageSkeleton({
  title,
  subtitle,
  actions,
  bottomActions,
  search,
  contentClassName,
  children,
}: PageSkeletonProps) {
  return (
    <PageLayout
      title={title ?? <Skeleton className="h-7 w-48 rounded" />}
      subtitle={subtitle}
      actions={actions}
      bottomActions={bottomActions}
      search={search ? { ...search, onChange: search.onChange ?? noop } : undefined}
      contentClassName={contentClassName}
    >
      <div role="status" aria-label="Loading page">
        {children}
      </div>
    </PageLayout>
  )
}
